import { Component } from '@angular/core';

@Component({
  selector: 'app-registration-details',
  standalone: true,
  imports: [],
  templateUrl: './registration-details.component.html',
  styleUrl: './registration-details.component.css'
})
export class RegistrationDetailsComponent24 {

}
